export function QuoteBlock({ content }: { content: Record<string, unknown> }) {
  const quote = typeof content.quote === "string" ? content.quote : "";
  const attribution = typeof content.attribution === "string" ? content.attribution : "";
  const role = typeof content.role === "string" ? content.role : "";
  const company = typeof content.company === "string" ? content.company : "";
  const credit = [attribution, role, company].filter(Boolean).join(" · ");
  return (
    <blockquote className="mx-auto max-w-3xl px-4 py-8">
      <div className="rounded-[var(--border-radius)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-sm">
        <p className="text-xl leading-relaxed text-[var(--color-text)]">“{quote}”</p>
        {credit && <footer className="mt-4 text-sm text-[var(--color-secondary)]">— {credit}</footer>}
      </div>
    </blockquote>
  );
}
